<template>
    <div id="desktop_sidebar">
        <div class="sidebar-logo">
            <router-link :to="{ name: 'HomeMenu' }">
                <groomy-logo />
            </router-link>
        </div>
        <ul class="sidebar-menu">
            <li v-for="menu in menus" :key="menu.to.name" class="sidebar-item">
                <router-link
                    :to="menu.to"
                    active-class="menuActive"
                    class="sidebar-tile"
                >
                    <span class="sidebar-tile-icon">
                        <font-awesome-icon :icon="menu.icon" />
                    </span>
                    <span class="sidebar-tile-label">{{ $t(menu.title) }}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import Navigation from '@/mixins/Navigation.js'
import Menus from '@/assets/js/menus'

export default {
    name: 'NavDesktopSidebar',
    mixins: [Navigation],
    data() {
        return {
            menus: [],
            events_tab: {
                'User::AccessRightsReloaded': this.reloadMenus
            }
        }
    },
    watch: {
        $route() {
            this.$store.commit('nav/close')
        }
    },
    created() {
        Menus.setInstance(this)
        this.reloadMenus()
    },
    methods: {
        reloadMenus() {
            const menus = Menus.user()
            this.menus = menus.filter(menu => menu.desktop && menu.to && menu.to.name !== 'displaySettings')
        }
    }
}
</script>
